import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import styles from './StripeRegistration.module.scss';
import StripeRegistrationButton from '../StripeRegistrationButton/StripeRegistrationButton';

const StripeRegistration: React.FC = () => {
	return (
		<>
			<Text tx='component.checkStripeSetup.text1' className={styles.text} />
			<Text tx='component.checkStripeSetup.text2' className={styles.textBold} />
			<div className='mt-4'>
				<StripeRegistrationButton />
			</div>
		</>
	);
};

export default StripeRegistration;
